"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DispatcherFunction = void 0;
var DispatcherFunction = function DispatcherFunction(eventName, eventObj) {
  try {
    if (window.messageToNative) {
      eventObj['eventName'] = eventName;
      window.messageToNative(JSON.stringify(eventObj));
    } else if (window.external && window.external.NativeDispatch) {
      window.external.NativeDispatch(eventName, JSON.stringify(eventObj));
    }
  } catch (error) {
    console.log('an exception occured ', error);
  }
};
exports.DispatcherFunction = DispatcherFunction;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/common/DispatcherFunction.js
 ** module id = 660
 ** module chunks = 0
 **/